<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control e-control">
        <label-wrapper :label-settings="config"></label-wrapper>
        <div v-if="asField">
            <display-value :id="config.id" :value="value"></display-value>
        </div>
        <div v-else>
            <ejs-listview
                v-bind="syncfusionConfig"
                v-model="value"
                :cssClass="cssClass"
                :dataSource="listOptions"
                :placeholder="ddStoreFilter(config.placeholder)"
                @select="itemSelect($event); action($event, 'onclick')"
                @actionComplete="actionComplete($event)"
                :ref="ref"
                :data-test-id="dataTestId"
                :enabled="!config.disabled"
                :template="itemTemplate"
            ></ejs-listview>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

export const listViewCmp = {
    data() {
        return {
            searchValue: '',
            searchAdded: false,
            headerClickAdded: false
        };
    },
    mixins: [controlMixins],
    computed: {
        cssClass() {
            let cssClass = this.config.cssClass;
            if (this && this.config && this.config.allowSearch) {
                if (typeof cssClass !== 'undefined') {
                    cssClass += ' searchable-listview';
                } else {
                    cssClass = 'searchable-listview';
                }
            }
            return cssClass;
        },
        ref() {
            return this.config.ref || this.config.id;
        },
        listOptions() {
            let tmpOptions = this.config.dataSource || this.config.options || this.options;
            if (tmpOptions.length && this.config.allowSearch) {
                if (!this.searchAdded) {
                    let search = [{
                        text: 'search_input',
                        value: 'search_input',
                        htmlAttributes: { 'class': "search-input" },
                        enabled: false
                    }];
                    for (let i in tmpOptions) {
                        if (typeof tmpOptions[i].child !== 'undefined') {
                            tmpOptions[i].child = [...search, ...tmpOptions[i].child];
                        }
                    }
                    this.searchAdded = true;
                }
            }
            return tmpOptions;
        },
        itemTemplate() {
            if (!this.config.itemTemplate && !this.config.allowSearch) return false;
            let templateId = 'itemTemplate_' + this.config.name;
            let draggableArguments = '';
            if (this.config.isDraggable) {
                draggableArguments = ' draggable="true" @dragstart="onDragStart($event)" ';
            }
            let onDragStart = (event) => {
                if (typeof this.action === 'function') {
                    this.action(event, 'ondragstart');
                }
            };
            let tmpItemTemplate = this.config.itemTemplate ? this.config.itemTemplate : '<span class="e-list-item-header" >{{data.text}}</span>';
            let tmpTemplate = this.config.allowSearch ? '<div v-if="data.value === \'search_input\'">'
                + '<span class="e-input-group e-control-wrapper">'
                + '<input v-model="searchValue" @input="updateSearchValueFnc" name="search_input" placeholder="Start typing for search" autocomplete="off" aria-label="search" class="e-control e-textbox e-lib e-input" type="text" role="textbox" value="">'
                + '<span class="e-clear-icon e-clear-icon-hide" aria-label="close" role="button"></span>'
                + '</span>'
                + '</div>'
                + '<div v-else>' + tmpItemTemplate + '</div>' : tmpItemTemplate;
            return library.createTemplateComponent(templateId,
                {
                    template: '<div ' + draggableArguments + ' @dblclick="dblclick($event)" :itemText="data.text" :itemValue="data.value">' + tmpTemplate + '</div>',
                    data() {
                        return {
                            config: this.config,
                            data: {
                                searchValue: ''
                            },
                        };
                    },
                    methods: {
                        onDragStart(event) {
                            if (event.target.attributes
                                && event.target.attributes.itemtext
                                && event.target.attributes.itemtext.value
                                && event.target.attributes.itemvalue
                                && event.target.attributes.itemvalue.value) {
                                event.additionalData = {
                                    text: event.target.attributes.itemtext.value,
                                    value: event.target.attributes.itemvalue.value
                                };
                            }
                            onDragStart(event);
                        },
                        dblclick(event) {
                            if (typeof this.action === 'function') {
                                this.action(event, 'ondblclick');
                            }
                        },
                        action: this.action,
                        updateSearchValue: this.updateSearchValue,
                        updateSearchValueFnc() {
                            this.updateSearchValue(this.searchValue);
                        }
                    }
                });
        }
    },
    created() {
        document.addEventListener('keydown', function (event) {
            if (event.key === "Backspace" && event.target.name === 'search_input') {
                event.stopPropagation();
            }
        }, true);
    },
    methods: {
        updateSearchValue(searchValue) {
            this.toggleElements(searchValue);
        },
        itemSelect(event) {
            if (event && event.data && event.data.child) {
                this.toggleElements('');
                let tmpContent = document.querySelectorAll('#' + this.ref + ' .e-content');
                if (tmpContent && tmpContent.length) {
                    tmpContent[0].addEventListener('scroll', (event) => {
                        let searchLi = document.querySelectorAll('#' + this.ref + ' .search-input');
                        for (let i = 0; i < searchLi.length; i++) {
                            searchLi[i].style.marginTop = -36 + event.target.scrollTop + 'px';
                        }
                    }, true);
                }
                let searchInputs = document.querySelectorAll('#' + this.ref + ' [name=search_input]');
                for (let i = 0; i < searchInputs.length; i++) {
                    searchInputs[i].value = '';
                }
            }
        },
        toggleElements(searchValue) {
            let listElements = document.querySelectorAll('#' + this.ref + ' .e-list-item');
            for (let i = 0; i < listElements.length; i++) {
                if (listElements[i].classList.contains('e-has-child') || listElements[i].classList.contains('search-input')) continue;
                if (searchValue && listElements[i].innerText.toLowerCase().indexOf(searchValue.toLowerCase()) === -1) {
                    listElements[i].classList.add('hidden-by-search');
                } else {
                    listElements[i].classList.remove('hidden-by-search');
                }
            }
        },
        addHeaderClick() {
            if (this.headerClickAdded) return;
            if (this.$refs[this.ref] && typeof this.$refs[this.ref]?.ej2Instances?.headerEle !== 'undefined') {
                this.headerClickAdded = true;
                let prevClick = this.$refs[this.ref].ej2Instances.headerEle.onclick;
                this.$refs[this.ref].ej2Instances.headerEle.onclick = () => {
                    this.action(null, 'onclick');
                    if (typeof prevClick === 'function') prevClick();
                };
            }
        },
        actionComplete() {
            this.addHeaderClick();
        }
    },
    components: {
        "ejs-listview": defineAsyncComponent(() => import('@common/syncfusion/listView'))
    }
};

export default listViewCmp;
</script>

<style scoped>
:deep(.search-input) {
    position: absolute !important;
    margin-top: -36px;
    z-index: 1;
    background-color: white !important;
    opacity: 1 !important;
    width: 100%;
}
:deep(.hidden-by-search) {
    display: none;
}
:deep(.searchable-listview .e-list-parent[pid]) {
    padding-top: 36px;
}
</style>
